import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useAiContext } from 'aiStudio/context/AiContext';

const useStyles = makeStyles(() => ({
  container: {
    backgroundColor: '#212121',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1rem',
    justifyContent: 'start',
  },
  card: {
    width: 240,
    backgroundColor: '#1f1f1f',
    border: '2px solid #444',
    color: '#ccc',
    borderRadius: '1rem',
    padding: '1.5rem 1rem',
    textAlign: 'start',
    position: 'relative',
    transition: 'all 0.2s ease-in-out',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#2b2b2b',
    },
  },
  active: {
    borderColor: '#e6616a',
  },
  disabled: {
    borderColor: '#333',
    opacity: 0.5,
    cursor: 'default',
    '&:hover': {
      backgroundColor: '#1f1f1f',
    },
  },
  icon: {
    fontSize: '2rem',
    marginBottom: '0.5rem',
    color: '#e6616a',
  },
  title: {
    fontSize: '1.1rem',
    marginBottom: '0.5rem',
    color: '#ccc',
  },
  description: {
    fontSize: '0.9rem',
    marginBottom: 0,
    color: '#999',
  },
  badge: {
    position: 'absolute',
    top: 12,
    right: 10,
    backgroundColor: '#e6616a',
    color: '#fff',
    padding: '4px 10px',
    borderRadius: '999px',
    fontSize: '0.7rem',
    fontWeight: 600,
    boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
  },
}));

const CardGroup = () => {
  const { cards, selectType } = useAiContext();
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {cards.map(card => {
        const isDisabled = card.disabled;
        const classNames = [classes.card, card.active ? classes.active : '', isDisabled ? classes.disabled : ''].join(' ');

        return (
          <div
            key={card.id}
            onClick={() => {
              if (!isDisabled) {
                selectType(card.id);
              }
            }}
            className={classNames}
          >
            <div className={classes.icon}>{card.icon}</div>
            <h3 className={classes.title}>{card.title}</h3>
            <p className={classes.description}>{card.description}</p>

            {isDisabled && <div className={classes.badge}>Coming Soon</div>}
          </div>
        );
      })}
    </div>
  );
};

export default CardGroup;
